import React from "react";
import ReactMarkdown from "react-markdown";
import { Components } from "react-markdown";

interface MarkdownRendererProps {
  markdown: string;
}

interface ThemeComponents {
  children?: React.ReactNode;
}

const newTheme: Partial<Components> = {
  h3: ({ children }: ThemeComponents) => (
    <h3 className="text-sm font-semibold mt-3 mb-4 text-foreground/80">
      {children}
    </h3>
  ),

  p: ({ children }: ThemeComponents) => (
    <p className="my-4 text-sm text-foreground/70">
      {children}
    </p>
  ),

  code: ({ children }: ThemeComponents) => (
    <code className="px-3 py-2 rounded-md text-xs font-mono bg-muted">
      {children}
    </code>
  ),

  br: () => <div className="h-4" />,
};

export default function MarkdownRenderer({
  markdown = "",
}: MarkdownRendererProps) {
  const formattedMarkdown = markdown.replace(/\\n\\n/g, "\n\n");

  return (
    <ReactMarkdown components={newTheme} skipHtml>
      {formattedMarkdown}
    </ReactMarkdown>
  );
}
